<template>
  <div class="view--edit">
    <loader v-if="loader"></loader>

    <background
      :image="ui.bg"
    ></background>

    <div class="panel">
      <div class="container">
        <div class="row no-gutters justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <div class="panel-header">
              <div class="title">{{ $t('edit.title') }}</div>
              <div class="caption">
                {{ $t('edit.desc') }}
              </div>
            </div>
            <div class="panel-body">
              <div class="o-form">
                <div class="row no-gutters">
                  <div class="col">
                    <div class="o-form__row">
                      <div class="o-form__icon">
                        <i class="material-icons">portrait</i>
                      </div>
                      <div class="o-form__content">
                        <div class="o-form__label">
                          {{ $t('edit.name') }}
                        </div>
                        <div class="o-form__value">
                          <input type="text" class="o-form__input" :placeholder="$t('common.enter')" v-model.trim="name">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters">
                  <div class="col">
                    <div class="o-form__row">
                      <div class="o-form__icon">
                        <i class="material-icons">wc</i>
                      </div>
                      <div class="o-form__content">
                        <div class="o-form__label">
                          {{ $t('edit.gender') }}
                        </div>
                        <div class="o-form__value">
                          <div class="pill-radio">
                            <input class="pill-radio__input" type="radio" id="male" value="1" v-model="gender">
                            <label for="male" class="pill-radio__label">{{ $t('edit.male') }}</label>
                          </div>
                          <div class="pill-radio">
                            <input class="pill-radio__input" type="radio" id="female" value="0" v-model="gender">
                            <label for="female" class="pill-radio__label">{{ $t('edit.female') }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters">
                  <div class="col">
                    <div class="o-form__row">
                      <div class="o-form__icon">
                        <i class="material-icons">today</i>
                      </div>
                      <div class="o-form__content">
                        <div class="o-form__label">
                          {{ $t('edit.birthday') }}
                        </div>
                        <div class="o-form__value">
                          <datepicker
                            :value="birthday"
                            :yearFirst="true"
                            v-on:update:date="birthday = $event"
                            :yearLength="100"
                            :yearOffset="-100"
                          ></datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <template
                  v-if="card.brandFields.length > 0"
                >
                  <div class="row no-gutters">
                    <div class="col">
                      <div class="o-form__row">
                        <div class="o-form__icon">
                          <i class="material-icons">badge</i>
                        </div>
                        <div class="o-form__content">
                          <div class="o-form__label">{{ $t('entry.common:additionalInformation') }}</div>
                          <div
                            class="row brand-field"
                            v-for="field in card.brandFields"
                            v-bind:key="field.token"
                          >
                            <template v-if="editingCustomFields.find((editingField) => field.token === editingField.token)">
                              <div
                                class="col"
                                v-if="field.type === 'email'"
                              >
                                <div class="o-form__row">
                                  <div class="o-form__content full">
                                    <div
                                      class="o-form__label"
                                      :class="{ 'is-mandatory': field.mandatory === '1' }"
                                    >
                                      {{ $t('entry.profile:email') }}
                                    </div>
                                    <div class="o-form__value">
                                      <input type="email" class="o-form__input" :placeholder="$t('common.enter')" v-model.trim="customFieldsData[field.token]" inputmode="email">
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <template
                                v-if="field.type === 'loc'"
                              >
                                <div class="col">
                                  <div class="o-form__row">
                                    <div class="o-form__content full">
                                      <div
                                        class="o-form__label"
                                        :class="{ 'is-mandatory': field.mandatory === '1' }"
                                      >
                                        {{ field.label || $t('entry.profile:locationCity') }}
                                      </div>
                                      <div class="o-form__value">
                                        <select
                                          class="o-form__select"
                                          v-on:change="locationAreaOptions = locationOptions[Number($event.target.value)] ? locationOptions[Number($event.target.value)].AreaList : []; customFieldsData[field.token] = null"
                                          required
                                        >
                                          <option>{{ $t('common.select') }}</option>
                                          <option
                                            v-for="(city, index) in locationOptions"
                                            v-bind:key="city.CityName"
                                            :value="index"
                                          >{{ $root.$i18n.locale === 'zh-Hant' ? city.CityName : city.CityEngName }}</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col">
                                  <div class="o-form__row">
                                    <div class="o-form__content full">
                                      <div
                                        class="o-form__label"
                                        :class="{ 'is-mandatory': field.mandatory === '1' }"
                                      >
                                        {{ $t('entry.profile:locationArea') }}
                                      </div>
                                      <div class="o-form__value">
                                        <select
                                          class="o-form__select"
                                          v-model="customFieldsData[field.token]"
                                          required
                                        >
                                          <option :value="null">{{ $t('common.select') }}</option>
                                          <option
                                            v-for="area in locationAreaOptions"
                                            v-bind:key="area.ZipCode + area.AreaName"
                                            :value="area.value"
                                          >{{ $root.$i18n.locale === 'zh-Hant' ? area.AreaName : area.AreaEngName }}</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                              <div
                                class="col"
                                v-if="field.type === 'text' || field.type === 'number' || field.type === 'tel'"
                              >
                                <div class="o-form__row">
                                  <div class="o-form__content full">
                                    <div
                                      class="o-form__label"
                                      :class="{ 'is-mandatory': field.mandatory === '1' }"
                                    >{{ field.label }}</div>
                                    <div class="o-form__value">
                                      <input
                                        :type="field.type"
                                        class="o-form__input"
                                        :placeholder="field.help ? $t('common.enter') + field.help :  $t('common.enter')"
                                        v-model.trim="customFieldsData[field.token]"
                                        :pattern="field.pattern || null"
                                        :inputmode="customFieldInputmode(field)"
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col"
                                v-if="typeof field === 'object' && field.type === 'select'"
                              >
                                <div class="o-form__row">
                                  <div class="o-form__content full">
                                    <div
                                      class="o-form__label"
                                      :class="{ 'is-mandatory': field.mandatory === '1' }"
                                    >{{ field.label }}</div>
                                    <div class="o-form__value">
                                      <select
                                        class="o-form__select"
                                        v-model="customFieldsData[field.token]"
                                        required
                                      >
                                        <option :value="null">{{ $t('common.select') }}</option>
                                        <option
                                          v-for="option in field.options"
                                          v-bind:key="field.token + option.label"
                                          :value="option.options || option.value"
                                        >{{ option.label }}</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <template
                                v-if="typeof field === 'object' && field.type === 'combo-select'"
                              >
                                <div class="col">
                                  <div class="o-form__row">
                                    <div class="o-form__content full">
                                      <div
                                        class="o-form__label"
                                        :class="{ 'is-mandatory': field.mandatory === '1' }"
                                      >{{ field.label }}</div>
                                      <div class="o-form__value">
                                        <select
                                          v-model="customFieldsComboData[field.token]"
                                          v-on:change="customFieldsData[field.token] = null"
                                          class="o-form__select"
                                          required
                                        >
                                          <option :value="null">{{ $t('common.select') }}</option>
                                          <option
                                            v-for="option in field.options"
                                            v-bind:key="field.token + option.label"
                                            :value="option.options"
                                          >{{ option.label }}</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col">
                                  <div class="o-form__row">
                                    <div class="o-form__content full">
                                      <div
                                        class="o-form__label"
                                        :class="{ 'is-mandatory': field.mandatory === '1' }"
                                      ></div>
                                      <div class="o-form__value">
                                        <select
                                          class="o-form__select"
                                          v-model="customFieldsData[field.token]"
                                          required
                                        >
                                          <option :value="null">{{ $t('common.select') }}</option>
                                          <option
                                            v-for="option in customFieldsComboData[field.token]"
                                            v-bind:key="field.token + option.label"
                                            :value="option.value"
                                          >{{ option.label }}</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </template>
                            <template v-else>
                              <div class="col col-auto brand-field-label">{{ field.label }}</div>
                              <div class="col brand-field-value">
                                {{ field.value }}
                                <i v-if="field.editable" class="material-icons brand-field-edit-icon" @click="onClickEditCustomField(field)">edit</i>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="panel-footer">
              <div class="row narrow-gutters">
                <div class="col">
                  <button class="btn btn-lg btn-block btn-secondary" v-on:click="cancel()">{{ $t('common.cancel') }}</button>
                </div>
                <div class="col">
                  <button class="btn btn-lg btn-block" v-on:click="submit()">{{ $t('common.submit') }}</button>
                </div>
              </div>
              <div class="caption" v-html="$t('edit.termsWithData', { brand: ui.name, data: ui.required, dataEn: ui.requiredEn })" v-if="ui.required"></div>
              <div class="caption" v-html="$t('edit.terms')" v-else></div>
            </div>
            <i18n-picker></i18n-picker>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import { mapState, mapMutations, mapActions } from 'vuex';

import Axios from '@/helpers/axios';
import CityCountry from '@/helpers/city-country.json';

import Loader from '@/components/Loader.vue';
import I18nPicker from '@/components/I18nPicker.vue';
import Datepicker from '@/components/DatePicker.vue';
import Background from '@/components/Entry/Background.vue';

const moment = require('moment');
require('moment/locale/zh-tw');

export default {
  name: 'Edit',
  components: {
    Background,
    I18nPicker,
    Loader,
    Datepicker,
  },
  data() {
    return {
      ui: {
        id: null,
        name: null,
        logo: null,
        bg: null,
        required: null,
      },

      facebookId: null,
      facebookName: null,
      facebookBirthday: null,
      facebookGender: null,
      facebookEmail: null,

      name: '',
      gender: null,
      birthday: null,

      editingCustomFields: [],
      customFieldsData: {},
      customFieldsComboData: {},
      locationOptions: CityCountry,
      locationAreaOptions: CityCountry[0].AreaList,
    };
  },
  watch: {
    facebookName(value) {
      this.name = value;
    },
    facebookGender(value) {
      if (value === 'male') {
        this.gender = '1';
      } else if (value === 'female') {
        this.gender = '0';
      }
    },
    facebookBirthday(value) {
      if (value) {
        const facebookBirthday = this.facebookBirthday.split('/');
        this.birthday = new Date(Date.UTC(
          facebookBirthday[2],
          facebookBirthday[0] - 1,
          facebookBirthday[1],
          0, 0, 0, 0,
        ));
      }
    },
  },
  computed: {
    ...mapState([
      'loader',
      'client',
      'card',
      'user',
    ]),
  },
  methods: {
    ...mapMutations([
      'setLoader',
      'setDtk',
      'setUtk',
    ]),
    ...mapActions([
      'getCard',
    ]),
    formatter(date) {
      return moment(date).format('l');
    },
    onClickEditCustomField(field) {
      this.customFieldsData[field.token] = null;
      this.editingCustomFields.push(field);
    },
    customFieldInputmode(field) {
      if (typeof field === 'string' && field === 'email') {
        return 'email';
      } else if (typeof field === 'object' && field.type === 'tel') {
        return 'tel';
      } else if (typeof field === 'object' && field.type === 'number') {
        return 'numeric';
      }

      return 'text';
    },
    cancel() {
      this.$router.push({ name: 'Index' });
    },
    submit() {
      if (!this.name) {
        this.$root.$message.error(this.$i18n.t('edit.nameEmpty'));
        return;
      }

      if (this.gender === null) {
        this.$root.$message.error(this.$i18n.t('edit.genderEmpty'));
        return;
      }

      if (!this.birthday) {
        this.$root.$message.error(this.$i18n.t('edit.birthdayEmpty'));
        return;
      }

      if (this.editingCustomFields.length !== 0) {
        // 檢查附加欄位未填寫
        const emptyCustomFields = [];

        this.editingCustomFields.forEach((field) => {
          if (field.mandatory === '1' &&
            (this.customFieldsData[field.token] === null || this.customFieldsData[field.token] === '')
          ) {
            let fieldName = '';
            if (field.label) {
              fieldName = field.label;
            } else if (field === 'email') {
              fieldName = 'Email';
            } else if (field === 'loc') {
              fieldName = this.$i18n.t('entry.profile:location');
            }

            emptyCustomFields.push(fieldName);
          }
        });

        // 如果大於 0，顯示錯誤並 return
        if (emptyCustomFields.length > 0) {
          swal.fire({
            text: this.$i18n.t('entry.profile:customFieldsEmpty', { field: emptyCustomFields[0] }),
            confirmButtonText: this.$i18n.t('common.ok'),
          });
          return;
        }

        // 檢查附加欄位填寫格式是否正確
        const invalidCustomFields = [];

        this.editingCustomFields.forEach((field) => {
          if (field.mandatory === '0' &&
            (this.customFieldsData[field.token] === null || this.customFieldsData[field.token] === '')
          ) {
            return;
          }

          if (field.type === 'email') {
            const emailRe = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!emailRe.test(this.customFieldsData[field.token])) {
              invalidCustomFields.push('email');
            }
          } else if (field.pattern) {
            const re = new RegExp(field.pattern);
            if (!re.test(this.customFieldsData[field.token])) {
              invalidCustomFields.push(field);
            }
          }
        });

        // 如果大於 0，顯示錯誤並 return
        if (invalidCustomFields.length > 0) {
          let fieldName = '';
          if (invalidCustomFields[0].label) {
            fieldName = invalidCustomFields[0].label;
          } else if (invalidCustomFields[0] === 'email') {
            fieldName = 'Email';
          } else if (invalidCustomFields[0] === 'loc') {
            fieldName = this.$i18n.t('entry.profile:location');
          }

          swal.fire({
            text: invalidCustomFields[0].help ? this.$i18n.t('entry.profile:customFieldsInvalidWithHelp', { field: fieldName, help: invalidCustomFields[0].help }) : this.$i18n.t('entry.profile:customFieldsInvalid', { field: fieldName }),
            confirmButtonText: this.$i18n.t('common.ok'),
          });
          return;
        }
      }

      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        brand_id: this.$route.params.brand,
        dtk: this.client.dtk,
        name: this.name,
        sex: this.gender,
        birth: moment(this.birthday).format('YYYY/MM/DD'),
      };

      if (this.facebookId) {
        data.fb_id = this.facebookId;
      }

      if (this.facebookEmail) {
        data.email = this.facebookEmail;
      }

      if (this.editingCustomFields.length !== 0) {
        data.custom_fields = this.customFieldsData;
      }

      Axios({
        method: 'post',
        url: '/User/UpdateUser',
        data,
      })
        .then((response) => {
          if (response.data.code === 500) {
            this.$root.$message.success(this.$i18n.t('edit.success'));
            this.$router.push({ name: 'Index' });
          } else {
            this.$root.$message.error(this.$i18n.t('edit.success'));
          }
        });
    },
    autofillUserData(data) {
      if ('name' in data) {
        this.name = data.name;
      }
      if ('sex' in data) {
        this.gender = data.sex;
      }
      if ('birth' in data) {
        this.birthday = moment(data.birth, 'YYYY-MM-DD').toDate();
      }
      if ('fb_id' in data) {
        this.facebookId = data.fb_id;
      }
    },
  },
  created() {
    const data = {
      ...this.$route.query,
      lang: this.$i18n.locale,
      p: this.client.phoneType,
      brand_id: this.$route.params.brand,
      dtk: this.client.dtk,
    };

    Axios({
      method: 'post',
      url: '/Login_w/verifyLogin',
      data,
    })
      .then((response) => {
        if (response.data.code === 500) {
          if (!response.data.data.logged_in) {
            this.$router.push({ name: 'Entry' });
            return;
          }

          this.ui = response.data.data.brand;
          this.cellCountry = response.data.data.brand.country_iso;

          this.ui.requiredEn = this.ui.required
            .replace(/、/g, ', ')
            .replace('手機號碼', 'mobile number')
            .replace('姓名', 'full name')
            .replace('性別', 'gender')
            .replace('生日', 'date of birth');

          this.autofillUserData(response.data.data.user_data);

          if (response.data.data.utk) {
            this.setUtk(response.data.data.utk);
          }

          this.setLoader(false);
        }
      });
  },
  mounted() {
    this.card.brandFields.forEach((field) => {
      if (field.type === 'combo-select') {
        this.$set(this.customFieldsComboData, field.token, null);
      }
    });
  },
};
</script>

<style lang="sass" scoped>
@import '../../../assets/sass/compoments/o-panel.sass'
@import '../../../assets/sass/compoments/o-form.sass'

.view--edit
  width: 100%
  height: 100%

  color: white

  .panel
    padding: 20px 0

    &-header
      .caption
        font-size: 0.875rem

    .brand-field
      font-size: 0.875rem

      &-label
        color: #3F51B5
        font-weight: bold

      &-value
        text-align: right

      &-edit-icon
        margin-left: 4px
        opacity: .5

        font-size: 0.875rem

        transform: translateY(2px)
        cursor: pointer
</style>
